export default {
    draft: 'Draft',
    published: 'Published'
}
